<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="building"></b-icon>
            <div class="headerTxt mLeft">
              ADMINISTRACIÓN
            </div>
          </div>
          <div class="alignIcon bold">Admin_Portal_Comercial</div>
        </div>
   <div>
        <div class="subtitulos">
          PORTAL COMERCIAL
        </div>
      </div>
        <div class="noAlTope">
          <b-tabs>
            <!--<b-tab title="Pagos recurrentes">
              <validation-observer
                ref="observer"
                v-slot="{ handleSubmit }"
                class="mt-2"
              >
                <b-form @submit.stop.prevent="handleSubmit(generar)">
                  <b-row>
                    <b-col>
                      <b-row class="ml-2">
                        <b-col cols="5">
                          <label>Nombre del Paciente: *</label>
                          <b-form-input
                            maxlength="50"
                            placeholder="Nombre paciente"
                            required
                            v-model.trim="filtro.tipoBusqueda"
                          ></b-form-input>
                          <b-form-invalid-feedback>
                            El nombre es requerido
                          </b-form-invalid-feedback>
                        </b-col>
                      </b-row>
                      <b-row class="ml-2">
                        <b-col cols="5">
                          <validation-provider
                            name="fcInicioVal"
                            :rules="{ required: true }"
                            v-slot="validationContext"
                          >
                            <label>Fecha de inicio:<validacion /></label>
                            <b-input-group size="sm" class="mb-2">
                              <b-form-datepicker
                                placeholder="Fecha inicio"
                                :max="new Date()"
                                @input="fechaMaxima($event)"
                              ></b-form-datepicker>
                            </b-input-group>
                            <validacion
                              :texto="
                                validationContext.errors[0]
                                  ? validationContext.errors[0]
                                  : ' '
                              "
                            />
                          </validation-provider>
                        </b-col>
                        <b-col cols="5">
                          <validation-provider
                            name="fcFinVal"
                            :rules="{ required: true }"
                            v-slot="validationContext"
                          >
                            <label>Fecha de fin:<validacion /></label>
                            <b-input-group size="sm" class="mb-2">
                              <b-form-datepicker
                                placeholder="Fecha fin"
                                v-model="filtro.fechaFin"
                                :max="
                                  filtro.fechaInicio.addDays(diasMaximoMes) >
                                  new Date()
                                    ? new Date()
                                    : filtro.fechaInicio.addDays(diasMaximoMes)
                                "
                                :min="filtro.fechaInicio"
                              ></b-form-datepicker>
                            </b-input-group>
                            <validacion
                              :texto="
                                validationContext.errors[0]
                                  ? validationContext.errors[0]
                                  : ' '
                              "
                            />
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col></b-col>
                    <b-col></b-col>
                    <b-col class="text-right">
                      <b-button
                        variant="outline-primary"
                        :disabled="loader"
                        @click="obtenerDatos()"
                      >
                        <span v-if="!loader">Buscar</span>
                        <span v-else>
                          <b-spinner small></b-spinner>
                          Buscando...
                        </span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
              <b-row class="mt-1">
                <b-col cols="12">
                  <b-table
                    thead-tr-class="columnas"
                    :items="datosTabla"
                    :fields="fields"
                    :per-page="$registrosPorPaginaTabla"
                    :current-page="paginaActual"
                    responsive
                    class="parrafos"
                  >
                    <template v-slot:cell(DETALLE)="row">
                      <b-button-group>
                        <b-button
                          size="sm"
                          @click="abrirModal(row.item)"
                          variant="outline-danger"
                          ><font-awesome-icon
                            icon="eye"
                            v-b-popover.hover.top="'Detalle de lan'"
                        /></b-button>
                      </b-button-group>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-tab>-->
            <b-tab title="Automatización de Pagos Recurrentes" v-if="$localStorageService.can('Admin_01_Portal_Comer_comision')">
              <renovacionPortalComercial />
            </b-tab>
             <b-tab title="Comisión de Portal Comercial" v-if="$localStorageService.can('Admin_01_Portal_Comer_pago_rec')">
              <comisionPortal />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <b-modal v-model="show" :title="'Detalle del Plan'" size="xl">
      <div>
        <b-row class="mt-1">
          <b-col cols="12">
            <b-table
              thead-tr-class="columnas"
              :items="datosDetallePlan"
              :fields="fieldsDetallePlan"
              :per-page="$registrosPorPaginaTablaDetalle"
              :current-page="paginaActualDetalle"
              responsive
              class="parrafos"
            >
              <template v-slot:cell(Detalle)="row">
                <b-button size="sm" @click="row.toggleDetails">
                  {{ row.detailsShowing ? "Ocultar" : "Ver más" }}
                </b-button>
              </template>
              <template #row-details="row">
                <b-card>
                  <ul>
                    <b-table
                      thead-tr-class="columnas"
                      :items="row.item.detalleRenovacionAutomatica"
                      :fields="fieldsDetalleRenovacion"
                      :per-page="$registrosPorPaginaTablaDetalleRenovacion"
                      :current-page="paginaActualDetalleRenovacion"
                      responsive
                      class="parrafos"
                    >
                    <template v-slot:cell(fechaRenovacion)="row">
                        {{ row.item.fechaRenovacion | formatoFechaCorta }}
                     </template>
                    </b-table>
                    <div align="center" v-if="loaderDetalleRenovacion">
                      <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-col v-if="!loaderRenovacion">
                      <b-alert
                        v-if="
                          row.item.detalleRenovacionAutomatica !== undefined &&
                          row.item.detalleRenovacionAutomatica.length === 0
                        "
                        variant="warning"
                        show
                        >No hay datos
                      </b-alert>
                    </b-col>
                    <b-col v-if="!loaderDetalleRenovacion">
                      <b-pagination
                        v-if="
                          row.item.detalleRenovacionAutomatica !== undefined &&
                          row.item.detalleRenovacionAutomatica.length > 10
                        "
                        align="center"
                        v-model="paginaActualDetalleRenovacion"
                        :total-rows="row.item.detalleRenovacionAutomatica.length"
                        :per-page="$registrosPorPaginaTablaDetalleRenovacion"
                        aria-controls="tabla"
                      ></b-pagination>
                    </b-col>
                  </ul>
                </b-card>
              </template>
            </b-table>
            <div align="center" v-if="loaderDetalle">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-if="!loader">
              <b-alert
                v-if="
                  datosDetallePlan !== undefined &&
                  datosDetallePlan.length === 0
                "
                variant="warning"
                show
                >No hay datos
              </b-alert>
            </b-col>
            <b-col v-if="!loaderDetalle">
              <b-pagination
                v-if="
                  datosDetallePlan !== undefined && datosDetallePlan.length > 10
                "
                align="center"
                v-model="paginaActualDetalle"
                :total-rows="datosDetallePlan.length"
                :per-page="$registrosPorPaginaTablaDetalle"
                aria-controls="tabla"
              ></b-pagination>
            </b-col>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer">
        <b-button variant="outline-danger" @click="cerrarModal()"
          >Cerrar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
<script>
import Header from "../../components/Header.vue";
import comisionPortal from "./comisionPortal.vue";
import renovacionPortalComercial from "./renovacionPortalComercial.vue";
export default {
  name: "adminRenovacionPortalComercial",
  components: {
    Header,
    comisionPortal,
    renovacionPortalComercial
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      datosDetallePlan: [],
      datosDetalleRenovacion: [],
      fields: [],
      fieldsDetallePlan: [],
      fieldsDetalleRenovacion: [],
      registrosPorPagina: 10,
      paginaActual: 0,
      registrosPorPaginaDetalle: 10,
      paginaActualDetalle: 0,
      registrosPorPaginaDetalleRenovacion: 10,
      paginaActualDetalleRenovacion: 0,
      loader: false,
      loaderDetalle: false,
      loaderDetalleRenovacion: false,
      show: false,
      filtro: {
        fechaInicio: new Date(),
        fechaFin: null,
        tipoBusqueda: null,
      },
      diasMaximoMes: null,
      filtroDetalle: null 
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.fieldsDetalleRenovacion = [
      { key: "idRenovacion", label: "ID RENOVACION", sortable: true },
      { key: "codigoRespuesta", label: "CODIGO RESPUESTA", sortable: true },
      { key: "descripcionRespuesta", label: "DESCRIPICION ERROR", sortable: true },
      { key: "fechaRenovacion", label: "FECHA DE RENOVACION", sortable: true },
    ];
    this.fieldsDetallePlan = [
      { key: "idTicket", label: "ID TICKET", sortable: true },
      { key: "idPlan", label: "ID PLAN", sortable: true },
      { key: "plan", label: "NOMBRE PLAN", sortable: true },
      { key: "tipoTarjeta", label: "TIPO TARJETA", sortable: true },
      { key: "numeroPoliza", label: "Poliza", sortable: true },
      {
        key: "fechaInicioVigencia",
        label: "FECHA INICIO VIGENCIA",
        sortable: true,
      },
      { key: "fechaFinVigencia", label: "FECHA FIN VIGENCIA", sortable: true },
      { key: "fechaPago", label: "FECHA DE COMPRA", sortable: true },
      { key: "montoPagado", label: "MONTO PAGADO", sortable: true },
      { key: "idPaciente", label: "ID PACIENTE", sortable: true },
      { key: "tipoPersona", label: "TIPO DE ASEGURADO", sortable: true },
      { key: "paciente", label: "PACIENTE", sortable: true },
      { key: "correo", label: "CORREO", sortable: true },
      { key: "telefono", label: "TELEFONO", sortable: true },
      { key: "renovacion", label: "RENOVACION AUTOMATICO", sortable: true },
      "Detalle",
    ];
    this.fields = [
      { key: "idPaciente", label: "ID PACIENTE", sortable: true },
      { key: "nombrePaciente", label: "NOMBRE PACIENTE", sortable: true },
      { key: "planesContratados", label: "PLANES CONTRATADOS", sortable: true },
      {
        key: "planesConRenovacion",
        label: "PLANES CON RENOVACION AUTOMATICA",
        sortable: true,
      },
      {
        key: "planesSinRenovacion",
        label: "PLANES SIN RENOVACION AUTOMATICA",
        sortable: true,
      },
      {
        key: "planesContratados",
        label: "PLANES CONTRATADOS",
        sortable: true,
      },
      { key: "planesFinalizados", label: "PLANES FINALIZADOS", sortable: true },
      "DETALLE",
    ];
  },
  methods: {
    obtenerDatos() {
      let fechaActual = this.$moment(this.filtro.fechaInicio);
      let fechaF = this.$moment(this.filtro.fechaFin);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");
      this.loader = true;
      this.datosTabla = [];
      if (this.filtro.tipoBusqueda !== null) {
        this.filtro.tipoBusqueda = this.filtro.tipoBusqueda.toUpperCase();
      } else {
        this.filtro.tipoBusqueda = "";
      }
      const filtro = {
        fechaInicio: fechaInicial,
        fechaFin: fechaFinal,
        tipoBusqueda: this.filtro.tipoBusqueda,
      };
      this.filtroDetalle = JSON.parse(JSON.stringify(filtro));
      this.$http
        .post(this.$api + "reportes/adminRenovacionAutomaticaPortal", filtro)
        .then((respuesta) => {
          if (respuesta.data.data) {
            if (respuesta.data.data !== undefined) {
              this.datosTabla = respuesta.data.data;
            }
          }
        })
        .finally(() => {
          this.loader = false;
          this.paginaActual = 0;
        });
    },
    abrirModal(item) {
      this.obtenerDatosDetalle(item);
      setTimeout(() => {
        this.show = true;
      }, 500);
    },
    cerrarModal() {
      setTimeout(() => {
        this.show = false;
      }, 500);
    },
    fechaMaxima(event) {
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
    },
    obtenerDatosDetalle(item) {
      this.loaderDetalle = true;
      this.filtroDetalle.tipoBusqueda = item.nombrePaciente;
      this.$http
        .post(
          this.$api + "reportes/detalleRenovacionAutomaticaPortal",
          this.filtroDetalle
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            if (respuesta.data.data !== undefined) {
              this.datosDetallePlan = respuesta.data.data;
            }
          }
        })
        .finally(() => {
          this.loaderDetalle = false;
          this.paginaActualDetalle = 0;
        });
    },
  },
};
</script>

<style>
</style>